import Immutable from "immutable";
import React from "react";
import useFormComponentState from "../../../../common/forms/useFormComponentState";
import { SearchCriterion } from "../common/SearchCriterion";
import { ForecastComponent, ForecastComponentProps } from "./ForecastComponent";
import { requiredRolesType } from "../../../../common/types/search/search";

interface ForecastCriterionProps extends ForecastComponentProps {
	requiredRoles?: requiredRolesType;
}

export const FORECAST_CRITERION_INITIAL_STATE = Immutable.Map();

export function ForecastCriterion({
	criterionKey,
	label,
	prefix,
	quickSearch = false,
	requiredRoles,
	...props
}: ForecastCriterionProps) {
	const { currentInput, onInputChange, onClearInput } = useFormComponentState(
		criterionKey,
		FORECAST_CRITERION_INITIAL_STATE,
	);

	return (
		<SearchCriterion
			label={label}
			requiredRoles={requiredRoles}
			quickSearch={quickSearch}
		>
			<ForecastComponent
				{...props}
				label={label}
				criterionKey={criterionKey}
				currentInput={currentInput}
				onInputChange={onInputChange}
				onClearInput={onClearInput}
				prefix={prefix}
				quickSearch={quickSearch}
			/>
		</SearchCriterion>
	);
}
